const LEAD = { key: 'lead', value: 'Lead' }
const CUSTOMER = { key: 'customer', value: 'Customer' }
const ORDER = { key: 'order', value: 'Pedido' }
const ORDER_ITEM = { key: 'orderItem', value: 'Item de pedido' }

const WORKFLOW_TYPES = [LEAD, CUSTOMER, ORDER, ORDER_ITEM]

module.exports = {
  LEAD,
  CUSTOMER,
  ORDER,
  ORDER_ITEM,
  WORKFLOW_TYPES
}
